import { useQuery } from 'react-query'
import { fetchWrapper } from 'utils/fetchWrapper'
import toastr from 'react-hot-toast'
import { CACHE_AND_STALE_TIME } from 'constants/index'
import { StripeAccountPaymentMethod } from 'types/Stripe/StripeAccountPaymentMethods'

const getStripeAccountPaymentMethods = (accountID: string | undefined) => {
  if (!accountID) {
    Promise.reject('Stripe Account ID can not be null')
    return
  }
  // this is NOT JSON api end point
  return fetchWrapper<StripeAccountPaymentMethod[]>({
    url: `Stripe/accounts/ad20cf4a-76b4-4feb-b7b1-0779151e3fc7/payment-methods`,
    // url: `Stripe/accounts/${accountID}/payment-methods`,
    method: 'GET',
  })
}

export function useStripeAccountPaymentMethods(accountID: string | undefined) {
  const response = useQuery(
    ['StripeAccountPaymentMethods', accountID],
    () => getStripeAccountPaymentMethods(accountID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `failed to Fetch Account Payment Methods: ${error.message}`
          )
        }
      },
      enabled: Boolean(accountID),
      ...CACHE_AND_STALE_TIME,
    }
  )
  const defaultPaymentMethod = response.data?.find(
    (method) => method.isDefault === false
  )
  return {
    ...response,
    defaultPaymentMethod,
  }
}
